import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    NavigationExtras,
    CanLoad, Route
} from '@angular/router';
import { Observable } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { catchError, map } from 'rxjs/operators';
import { AdminService } from '../pages/admin/admin.service';
import { AlertService } from './alert.service';
import { AuthDataService } from './auth-data.service';
import { AuthService } from './auth.service';
import { UserService } from './user.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
    private token: string;
    private loading: boolean;

    constructor(
        private authService: AuthService,
        private router: Router,
        private alertService: AlertService,
        private adminService: AdminService,
        private userService: UserService,
        private authDataService: AuthDataService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let url: string = state.url;
        return this.checkLogin(url);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivate(route, state);
    }

    canLoad(route: Route) {
        let url = `/${route.path}`;
        return this.checkLogin(url);
    }

    checkLogin(url: string) {
        //fetch loggedin user if not found
        if (this.authDataService.getCurrentUser()) {
            return this.checkToken(url);
        } else {
            this.checkToken(url);
            return this.getCurrentUser();
        }

    }

    checkToken(url: string) {
        this.token = sessionStorage.getItem("token");

        // if (this.authService.isLoggedIn) { return true; }
        if (this.token != null && this.token != undefined) {
            return true;
        }

        // Store the attempted URL for redirecting
        this.authService.redirectUrl = url;

        // Create a dummy session id
        let sessionId = 123456789;

        // Set our navigation extras object
        // that contains our global query params and fragment
        let navigationExtras: NavigationExtras = {
            queryParams: { 'session_id': sessionId },
            fragment: 'anchor'
        };

        // Navigate to the login page with extras
        this.router.navigate(['/login'], navigationExtras);
        return false;
    }

    getCurrentUser(): Observable<boolean> {
        this.loading = true;
        let getCurrentUser = this.adminService.fetchLoggedinUser().pipe(
            map(data => {
                data.data.avatarUrl = 'public/assets/img/user2-160x160.jpg';
                data.data.email = data.data.email;
                data.data.name = data.data.name;
                data.data.adminId = data.data.id;
                data.data.username = data.data.username;
                data.data.clientId = data.data.client.id;
                data.data.company = data.data.client.company;
                data.data.connected = true;
                data.data.centralAdmin = data.data.userGroup.centralAdmin,
                this.authDataService.setCurrentUser(data.data);
                return true;
            }),
            catchError(err => {
                let details = err.json();
                console.log(details);
                if (details.apierror) {
                    this.alertService.error(details.apierror.message);
                } else {
                    this.alertService.error("Failed to reset password.");
                }
                return of(false);
            })
        )

        let getuserMenu = this.userService.getMenus().pipe(
            map(data => {
                this.authDataService.setNavigation(data.data);
                return true;
            }),
            catchError(err => {
                let details = err.json();
                console.log(details);
                if (details.apierror) {
                    this.alertService.error(details.apierror.message);
                } else {
                    this.alertService.error("Failed to fetch menus.");
                }
                return of(false);
            })
        )

        let join = forkJoin([getCurrentUser, getuserMenu]).pipe(
            map(
                (allResponses) => {
                    this.loading = false;
                    return allResponses[0] && allResponses[1];
                }
            ),
            catchError((error) => {
                this.loading = false;
                return of(false);
            })
        );
        return join;
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/services/auth-guard.service.ts